import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Image } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import { cancelButton, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import ViewReport from './ViewReport/ViewReport';
import ReportList from './ReportList/list';
import PrintReport from './ReportPrint';
import { notificationHeaderIcon } from '../../images';
import { getUser, invoke } from '../../AppServices';

const { headings } = vars;

const handleMail = async (obj) => {
  const result = await invoke({
    id: 'onDemandMail',
    paramValue: obj,
  });
  if (result?.messageId) {
    Toast.show({
      message: 'Success',
      description: 'Mail Sent Successfully.',
      type: 'success',
      position: 'top',
      direction: 'right',
      duration: 3000,
    });
  }
  return result;
};
const handleSMS = async (obj) => {
  await invoke({
    id: 'onDemandSMS',
    paramValue: obj,
  });
  Toast.show({
    message: 'Success',
    description: 'Sms Sent Successfully',
    type: 'success',
    position: 'top',
    direction: 'right',
    duration: 3000,
  });
};
const handlePrint = () => {
  window.print();
};

const handleDealerNotifyPreference = async (preference, data) => {
  const forMail = {
    customerEmail: data.customerEmail,
    finalrange: data.finalrange,
  };
  const forSMS = {
    customerContactNumber: data.customerContactNumber,
    finalrange: data.finalrange,
  };
  const { navigation } = data;
  if (preference === 'All') {
    await handleMail(forMail);
    await handleSMS(forSMS);
    handlePrint();
  } else if (preference === 'Email') {
    const result = await handleMail(forMail);
    if (!result?.messageId) {
      const smsResult = await handleSMS(forSMS);
      if (!smsResult.result) {
        handlePrint();
      }
    }
  } else if (preference === 'SMS') {
    const smsResult = await handleSMS(forSMS);
    if (!smsResult.result) {
      handlePrint();
    }
  } else if (preference === 'Print') {
    handlePrint(navigation);
  } else {
    Toast.show({
      message: 'Warning',
      description: 'Please set your nitification preference first.',
      type: 'warning',
      position: 'top',
      direction: 'left',
      duration: 3000,
    });
  }
};

export default {
  [ROUTES.uciReportList.name]: {
    screen: ReportList,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Captured Appraisals</Text>
    ),
    headerActions: [{ render: () => <Text /> }],
  },
  [ROUTES.uciReportListWithBackButton.name]: {
    screen: ReportList,
    expanded: true,
    title: ({ navigation }) => (
      <Text style={{ ...headings.pageHeading }}>
        {`${navigation?.state?.params?.item?.username} UCI Report List`}
      </Text>
    ),
    headerActions: [cancelButton],
  },
  [ROUTES.uciReportView.name]: {
    screen: ViewReport,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Appraisal Details</Text>
    ),
    headerActions: [
      {
        render: (props) => (
          <>
            <ReactTooltip
              place="bottom"
              type="dark"
              effect="float"
              id="notify-button"
            />
            {getUser().role.constructor !== Array ? (
              <div data-tip="Notify" data-for="notify-button">
                <Image
                  style={{
                    height: 24,
                    width: 24,
                    cursor: 'pointer',
                  }}
                  onClick={async () => {
                    const templatePresent = await invoke({
                      id: 'templatePresent',
                      paramValue: {},
                    });

                    if (templatePresent.result) {
                      const { navigation } = props;
                      const data = { _id: navigation.state.params.item._id };

                      const { result } = await invoke({
                        id: 'handleNotify',
                        paramValue: { data },
                      });

                      const toPass = {
                        customerEmail:
                          navigation?.state?.params?.item?.customerEmail,
                        finalrange: navigation?.state?.params?.item?.finalrange,
                        customerContactNumber:
                          navigation?.state?.params?.item
                            ?.customerContactNumber,
                        navigation,
                      };

                      await handleDealerNotifyPreference(result, toPass);
                    } else {
                      Toast.show({
                        message: 'Warning',
                        description: 'Please set notify templates first...',
                        type: 'warning',
                        position: 'top',
                        direction: 'left',
                        duration: 3000,
                      });
                    }
                  }}
                  source={notificationHeaderIcon}
                />
              </div>
            ) : null}
          </>
        ),
      },
      cancelButton,
    ],
  },
  [ROUTES.uciReportPrint.name]: {
    screen: PrintReport,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
  },
};
